import { get, post } from "aws-amplify/api";

const GetOrganizationReports = async ({ organizationId, year }) => {
  try {
    const { body } = await get({
      apiName: "boreas",
      path: `${organizationId}/reports`,
      options: {
        queryParams: { year: String(year) },
      },
    }).response;

    return body.json();
  } catch (err) {
    console.log(err);

    if (err.response?.body) {
      const errorMessage = JSON.parse(err.response.body).error;
      throw errorMessage;
    }

    throw err;
  }
};

const GetLocationMonthlyReport = async ({ organizationId, locationId, reportPeriod }) => {
  try {
    const { body } = await get({
      apiName: "boreas",
      path: `${organizationId}/reports/${locationId}/${reportPeriod}`,
    }).response;

    return body.json();
  } catch (err) {
    console.log(err);

    if (err.response?.body) {
      const errorMessage = JSON.parse(err.response.body).error;
      throw errorMessage;
    }

    throw err;
  }
};

const PostLocationMonthlyReportReview = async ({ organizationId, locationId, reportPeriod, note }) => {
  try {
    const { body } = await post({
      apiName: "boreas",
      path: `${organizationId}/reports/${locationId}/${reportPeriod}/review`,
      options: {
        body: { note },
      },
    }).response;

    return body.json();
  } catch (err) {
    console.log(err);

    if (err.response?.body) {
      const errorMessage = JSON.parse(err.response.body).error;
      throw errorMessage;
    }

    throw err;
  }
};

const GetLocationMonthlyReportPdf = async ({ organizationId, locationId, reportPeriod }) => {
  try {
    const { body, headers } = await get({
      apiName: "boreas",
      path: `${organizationId}/reports/${locationId}/${reportPeriod}/pdf`,
      options: {
        headers: { Accept: "application/pdf" },
      },
    }).response;

    const disposition = headers["content-disposition"] || headers["Content-Disposition"];
    const fileName = disposition?.split('filename="')[1]?.split('"')[0]
      || `Boreas-Compliance-Report-${locationId}-${reportPeriod}.pdf`;

    return { fileName, file: await body.blob() };
  } catch (err) {
    console.log(err);

    if (err.response?.body) {
      const errorMessage = JSON.parse(err.response.body).error;
      throw errorMessage;
    }

    throw err;
  }
};

const Methods = {
  GetOrganizationReports,
  GetLocationMonthlyReport,
  PostLocationMonthlyReportReview,
  GetLocationMonthlyReportPdf,
};

export default Methods;
